// Custom scripts.

window.addEventListener('load', () => {
  // Toggle open Buy RF mobile menu.
  // function openBuyRF() {
  //   const details = document.querySelector('menu-drawer .level-0:first-child details');
  //   if (!details.open) {
  //     details.summaryElement.click();
  //   }
  // }
  // const mql = matchMedia('(max-width: 1024px)');
  // if (mql.matches) openBuyRF();
  // mql.addEventListener('change', (event) => {
  //   if (event.matches) openBuyRF();
  // });
});
